<multi-file-upload *ngIf="!isNative" #multiFileUploadComponent [label]="label" [options]="options.Options" [hideUploadButton]="hideUploadButton">
</multi-file-upload>
<native-multi-file-upload *ngIf="isNative" #nativeMultiFileUploadComponent [label]="label" [options]="options"
    [hideUploadButton]="hideUploadButton" [uploadedFiles]="uploadedFiles" [takePhotosOnly]="options.PhotoOnly">
</native-multi-file-upload>